import type { ExportTableDialogProps } from "./types-export-table-dialog";
import { useExportTableDialog } from "./use-export-table-dialog";
import { ExportTableDialogView } from "./view-export-table-dialog";

/**
 * "Exportar Tabela" (Padrões Globais) sobre o `Dialog`: PDF, Planilha Excel ou Texto Separado, sem pré-seleção; Exportar
 * só habilita com formato escolhido (e, no Excel com `xlsxLayouts`, com a organização). Cabe ao chamador fechar o modal.
 * Mesma API e `data-testid` do antigo modal de `shared`.
 */
export function ExportTableDialog(props: ExportTableDialogProps) {
  const viewModel = useExportTableDialog(props);

  return <ExportTableDialogView {...viewModel} />;
}
ExportTableDialog.displayName = "ExportTableDialog";
